import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PLATFORM_LABELS = {
  uber: "Uber",
  bolt: "Bolt",
  heetch: "Heetch",
  prive: "Client privé",
};

export const PLATFORM_COLORS = {
  uber: "hsl(217.2 91.2% 59.8%)",
  bolt: "hsl(142.1 76.2% 45%)",
  heetch: "hsl(340 75% 55%)",
  prive: "hsl(43 96% 56%)",
};

export const EXPENSE_CATEGORIES = [
  { key: "carburant", label: "Carburant", icon: "Fuel" },
  { key: "recharge_electrique", label: "Recharge électrique", icon: "Zap" },
  { key: "lavage", label: "Lavage", icon: "Droplets" },
  { key: "telephone", label: "Téléphone", icon: "Smartphone" },
  { key: "internet", label: "Internet", icon: "Wifi" },
  { key: "assurance", label: "Assurance", icon: "ShieldCheck" },
  { key: "rc_pro", label: "RC Pro", icon: "Shield" },
  { key: "credit_vehicule", label: "Crédit véhicule", icon: "Banknote" },
  { key: "entretien", label: "Entretien", icon: "Wrench" },
  { key: "pneus", label: "Pneus", icon: "CircleDot" },
  { key: "freins", label: "Freins", icon: "Disc" },
  { key: "parking", label: "Parking", icon: "ParkingCircle" },
  { key: "peages", label: "Péages", icon: "Milestone" },
  { key: "autres", label: "Autres", icon: "MoreHorizontal" },
];

export function fmtEuro(v) {
  const n = Number(v || 0);
  return n.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 });
}

export function fmtNum(v, digits = 0) {
  return Number(v || 0).toLocaleString("fr-FR", { maximumFractionDigits: digits });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
